<template>
  <div
    class="main-day-filter"
  >
    <div
      v-if="dataConfig.length > 0 "
      class="container-toolbar"
    >
      <UCToolbar
        v-if="dataConfig.length < 5"
        class="content-toolbar"
        :is-bottom="false"
        :data="dataConfig"
        tabbar-link="1"
      >
        <template #tabs>
          <f7-tabs>
            <f7-tab
              v-for="(list, i) in dateList"
              :id="`${'tab-'}${i + 1}`"
              :key="i"
              :tab-active="i === 0"
            >
              <div class="display-flex justify-content-space-between align-items-center mt-4 mb-2 pl-2">
                <div class="display-flex size-16">
                  <span
                    class="field-number bg-color-tomate text-color-mora-white rounded-xl text-align-center font-medium  margin-right-half"
                  >
                    {{ list.item.length }}
                  </span>
                  <span class="font-medium">{{ list.item.length < 2 ? $t('common.customer') : $t('common.customers') }}</span>
                </div>
                <div class="size-14 font-medium pr-2">
                  {{ formatDateDay(list.Fecha) }}
                </div>
              </div>
              <div
                class="container-cards"
              >
                <f7-list
                  class="container-cards-list"
                  media-list
                >
                  <f7-list-item
                    v-for="(entity, j) in list.item"
                    :key="j"
                    link="#"
                    class="container-cards-list__item"
                    @click="SelectEntity(entity)"
                  >
                    <template #title>
                      <div class="container-cards-list__item--title truncate-x2">
                        <div class="display-flex justify-content-space-between align-items-center">
                          <div>
                            {{ GetTitle(entity) }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #after>
                      <div class="container-cards-list__item--after">
                        <img
                          src="@/static/icons/ic_shape_right.svg"
                        >
                      </div>
                    </template>
                    <template #subtitle>
                      <slot
                        name="subtitle"
                        :item="entity"
                      >
                        <div class="container-cards-list__item--subtitle">
                          <span class="truncate">{{ GetSubtitle(entity) }}</span>
                        </div>
                      </slot>
                    </template>
                  </f7-list-item>
                </f7-list>
              </div>
            </f7-tab>
          </f7-tabs>
        </template>
      </UCToolbar>
      <div
        v-else
        class="h-100 container-data-range"
      >
        <div class="display-flex align-items-center mt-4 mb-2 size-16 font-semibold">
          {{ `${formatDateDay(dateRange?.StartDate)} - ${formatDateDay(dateRange?.EndDate)}` }}
        </div>
        <div class="container-data-range__items">
          <div
            v-for="(list, i) in dateList"
            :key="i"
          >
            <div class="display-flex justify-content-space-between align-items-center mt-4 pl-2">
              <div class="display-flex size-16">
                <span
                  class="field-number bg-color-tomate text-color-mora-white rounded-xl text-align-center font-medium  margin-right-half"
                >
                  {{ list.item.length }}
                </span>
                <span class="font-medium">{{ DayString(list.Fecha).charAt(0).toUpperCase() + DayString(list.Fecha).slice(1).toLowerCase() }}</span>
              </div>
              <div class="size-14 font-medium pr-2">
                {{ formatDateDay(list.Fecha) }}
              </div>
            </div>
            <div class="container-cards">
              <f7-list
                class="container-cards-list"
                media-list
              >
                <f7-list-item
                  v-for="(entity, j) in list.item"
                  :key="j"
                  link="#"
                  class="container-cards-list__item"
                  @click="SelectEntity(entity)"
                >
                  <template #title>
                    <div class="container-cards-list__item--title truncate-x2">
                      <div class="display-flex justify-content-space-between align-items-center">
                        <div>
                          {{ GetTitle(entity) }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #after>
                    <div class="container-cards-list__item--after">
                      <img
                        src="@/static/icons/ic_shape_right.svg"
                      >
                    </div>
                  </template>
                  <template #subtitle>
                    <slot
                      name="subtitle"
                      :item="entity"
                    >
                      <div class="container-cards-list__item--subtitle">
                        <span class="truncate">{{ GetSubtitle(entity) }}</span>
                      </div>
                    </slot>
                  </template>
                </f7-list-item>
              </f7-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UCToolbar from '@/components/common/UCToolbar.vue';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import { useSettingRef } from '@erpagroapp/settings';

export default {
  name: 'UCDayFilter',
  components: {
    UCToolbar,
  },
  props: {
    defaultEntityList: { type: Array, default: null },
    defaultTitle: { type: String, default: '' },
    defaultSubtitle: { type: String, default: '' },
    dateFilter: { type: String, default: '' },
    dateRange: { type: Object, default: null },
  },

  emits: ['entity-selected'],

  data() {
    return {
      selection: null,
      dateList: [],
      today: null,
      tomorrow: null,
      language: useSettingRef('App.Idioma'),
    };
  },
  computed: {
    entityList() {
      if (this.defaultEntityList !== null) {
        return this.defaultEntityList;
      }
      return null;
    },
    dataConfig() {
      const tabsData = [];
      this.dateList.forEach((item, i) => {
        const elementTab = {
          title: this.DayString(item.Fecha),
          badge: '',
          href: '',
          tablink: i + 1,
        };
        tabsData.push(elementTab);
      });
      return tabsData;
    },
  },
  created() {
    const todayString = new Date();
    const tomorrowString = new Date(todayString);
    tomorrowString.setDate(tomorrowString.getDate() + 1);
    this.today = this.FormatDate(todayString);
    this.tomorrow = this.FormatDate(tomorrowString);
    this.GetDateList();
  },
  methods: {
    GetDateList() {
      // Ordenamos la lista por fecha
      this.entityList.sort(
        (a, b) => new Date(a[this.dateFilter]).getTime() - new Date(b[this.dateFilter]).getTime(),
      );

      let fechaAnterior = null;

      this.entityList.forEach((element) => {
        const fecha = this.FormatDate(element[this.dateFilter]);

        let array = [];

        if (fecha !== fechaAnterior) {
          this.dateList.push({ Fecha: element[this.dateFilter], item: [] });
          array = this.entityList.filter((f) => fecha === this.FormatDate(f[this.dateFilter]));
          this.dateList[this.dateList.length - 1].item = array;
        } else {
          array = this.entityList.filter((f) => fecha === this.FormatDate(f[this.dateFilter]));
          this.dateList[this.dateList.length - 1].item = array;
        }

        fechaAnterior = fecha;
      });

      // this.dateList = this.VerifyData(this.dateList);
    },

    FormatDate(date) {
      const opciones = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      };
      if (this.language) {
        return new Date(date).toLocaleDateString(this.language.Code, opciones);
      }
      return new Date(date).toLocaleDateString('es-Es', opciones);
    },
    formatDateDay(date) {
      if (date) {
        const newDate = HiDateTimeSupport.FormatDateTime(date, 'ddd DD/MM/YYYY');
        return newDate.charAt(0).toUpperCase() + newDate.slice(1).toLowerCase();
      }
      return '';
    },

    DayString(date) {
      const opciones = { weekday: 'long' };
      let day = null;
      if (this.language) {
        day = new Date(date).toLocaleDateString(this.language.Code, opciones);
      } else {
        day = new Date(date).toLocaleDateString('es-Es', opciones);
      }
      if (this.FormatDate(date) === this.today) {
        day = this.$t('common.today');
      }
      if (this.FormatDate(date) === this.tomorrow) {
        day = this.$t('common.tomorrow');
      }

      return day.toUpperCase();
    },

    GetTitle(entity) {
      let txtResult = '';
      if (this.defaultTitle.includes('.')) {
        const element = this.defaultTitle.split('.');
        txtResult += `${entity[element[0]][element[1]]}`;
      } else {
        txtResult = entity[this.defaultTitle];
      }
      return txtResult;
    },

    GetSubtitle(entity) {
      let txtResult = '';
      if (this.defaultSubtitle.includes('.')) {
        const element = this.defaultSubtitle.split('.');
        txtResult += `${entity[element[0]][element[1]]}`;
      } else {
        txtResult = entity[this.defaultSubtitle];
      }

      return txtResult;
    },

    SelectEntity(entity) {
      this.selection = entity;
      this.$emit('entity-selected', this.selection);
    },
  },
};
</script>

<style lang="scss">
.main-day-filter {
  height: 100%;
  .container-toolbar{
    background: var(--f7-page-bg-color);
    height: 100%;
    .content-toolbar {
      --f7-tabbar-link-active-color: var(--his-whispering-lilac);
      --f7-tabbar-link-active-bg-color: var(--his-mora-white);
      --f7-tabbar-link-inactive-color: #fff;
      --toolbar-bg-color: var(--his-tierra-grey);
      height: 100%;
      width: 100%;
      padding-left: 12px;
      padding-right: 12px;
      margin-top: -1px;
      padding-top: 10px;
      .tabs{
        height: 100%;
        .tab{
          height: 100%;
        }
      }
      .content-toolbar-elements {
        position: inherit;
        height: 50px;
        border-radius: 6px;
        .toolbar-inner {
          padding: 7px;
          .tab-link{
            border-radius: 6px!important;
            font-weight: 600;
            .content-title{
              color: var(--his-metal);
            }
          }
          .tab-link-active{
            .content-title{
              color: var(--his-darkness);
            }
          }
        }
      }
      .page-content{
        padding-top: 10px;
      }
    }
    .container-data-range{
      padding-left: 12px;
      padding-right: 12px;
      margin-top: -1px;
      padding-top: 10px;
      &__header{

      }
      &__items{
        height: calc(100% - 200px);
        overflow-y: scroll;
      }
    }

    .field-number{
      min-width: 25px;
    }

    .container-cards{
      overflow-y: scroll;
        height: calc(100% - 245px);
      .container-cards-list {
        margin: 0px;
        &__item {
          --f7-list-item-title-line-height: 1.2;
          background-color: var(--his-mora-white);
          margin: 8px 0px 8px 0px;
          border: 1px solid var(--f7-list-item-border-color);
          border-radius: 8px;
          border-bottom: 4px solid var(--f7-list-item-border-color);
          &--title {
            font-size: 18px;
          }
          &--after {
            height: 18px;
            margin-right: -35px;
          }

          &--subtitle {
            color: var(--his-metal-shade);
            font-size: 16px;
            font-weight: 500;
            align-items: center;
            margin-top: 8px;
          }

          .item-link .item-content .item-inner .item-title-row{
            padding-right: 10px;
            margin-top: 5px;
            .item-after{
              align-self: unset;
            }
          }

        }
      }
    }
  }
}
</style>
